"use client";

import { useEffect } from "react";
import { THEME_STORAGE_KEY, hasStoredTheme, syncTheme } from "@/lib/theme";

/**
 * Keeps an open page in step with the preference after it has loaded: when the
 * system switches between light and dark (and the visitor never chose one on
 * the toggle), and when the toggle is used in another tab. Without this the
 * page kept whatever theme it loaded with while other tabs moved on.
 */
export default function ThemeSync() {
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const onSystem = () => {
      if (!hasStoredTheme()) syncTheme();
    };
    const onStorage = (e: StorageEvent) => {
      if (e.key === THEME_STORAGE_KEY || e.key === null) syncTheme();
    };
    media.addEventListener("change", onSystem);
    window.addEventListener("storage", onStorage);
    return () => {
      media.removeEventListener("change", onSystem);
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return null;
}
